export enum ChangePasswordFieldNameEnum {
  CHANGE_PASSWORD = "changePassword",
  PASSWORD_FIELD_PREFIX = "password",
  CURRENT_PASSWORD = "currentPassword",
  NEW_PASSWORD = "password",
  CONFIRM_PASSWORD = "confirmPassword"
}
